<template>
  <div class="account-club">
    <club-summary
      class="account-club__summary"
    />

    <h3 class="account-club__title  account-club__title-calendar">
      График начисления бонусов
    </h3>
    <club-points-calendar
      class="account-club__calendar"
    />

    <h3 class="account-club__title account-club__title-history">
      История операций с бонусами
    </h3>
    <club-points-history
      class="account-club__history"
    />

    <div class="account-club__hint">
      С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте
      <ui-link href="mailto:helpme@fundayshop.com" color="black">
        helpme@fundayshop.com
      </ui-link>
      или по телефону <ui-link href="tel:8 800 770-01-01" color="black">
        8 800 770-01-01
      </ui-link>  (по России бесплатно), с 7:00 до 22:00 (мск)
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import ClubSummary from '@/components/account/club-summary.vue';
import ClubPointsHistory from '@/components/account/club-points-history.vue';
import ClubPointsCalendar from '@/components/account/club-points-calendar.vue';

export default {
  name: 'account-club',

  components: {
    ClubSummary,
    ClubPointsHistory,
    ClubPointsCalendar,
  },

  created() {
    if (this.$isServer) return;
    this.LOAD_PROMOS();
  },

  methods: {
    ...mapActions({
      LOAD_PROMOS: 'user/loadPromos',
    }),
  },

  serverPrefetch() {
    return this.$store.dispatch('club/getLevel', null, {root: true});
  },
};
</script>

<style lang="scss">
.account-club {
  margin-bottom: -88px;

  @include breakpoint("tablet") {
    margin-bottom: -80px;
  }

  @include breakpoint("desktop") {
    margin-bottom: -120px;
  }

  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 300;
    margin-top: 0;

    @include breakpoint("desktop") {
      font-size: 24px;
    }

    &-calendar {
      margin-bottom: 4px;

      @include breakpoint("tablet") {
        margin-bottom: 6px;
      }
    }

    &-history {
      margin-bottom: 20px;
    }
  }

  &__summary {
    margin-top: 28px;
    margin-bottom: 40px;

    @include breakpoint("tablet") {
      margin-top: 33px;
    }

    @include breakpoint("desktop") {
      margin-top: 0;
    }
  }

  &__history {
    margin-bottom: 24px;

    @include breakpoint("tablet") {
      margin-bottom: 40px;
    }
  }

  &__hint {
    padding: 12px;
    font-size: 16px;
    line-height: 24px;
    color: $gray;
    background: $white;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04),
                0 8px 24px rgba(0, 0, 0, .03),
                0 16px 32px rgba(0, 0, 0, .02);
  }

  &__calendar {
    margin-bottom: 40px;
  }
}
</style>
